import { useState, useEffect } from "react";
import { timestampService } from "../services/api/timestampService";
import { AdminMetrics, Timestamp } from "../types/api";

export const useTimestampService = () => {
  const [metrics, setMetrics] = useState<AdminMetrics | null>(null);
  const [timestamps, setTimestamps] = useState<Timestamp[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [metricsData, timestampsData] = await Promise.all([
        timestampService.getMetrics(),
        timestampService.getTimestamps(),
      ]);
      setMetrics(metricsData);
      setTimestamps(timestampsData);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Failed to fetch data"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { metrics, timestamps, loading, error, refetch: fetchData };
};
